import { snackbarState } from 'apollo/reactive-variables/snackbarState';
import { EditablePerisurgicalActivityPlan as EditablePerisurgicalActivityPlanUI } from 'components/activity-plan/perisurgical/EditablePerisurgicalActivityPlan';
import {
  useDraftActivityPlan,
  useDraftActivityPlanAPI
} from 'providers/DraftActivityPlanProvider';
import { useCurrentProgressionNum } from 'providers/hooks/useCurrentProgressionNum';
import React from 'react';
import { TargetProgression } from 'types/targetProgression';
import {
  copyAllExercises,
  copyUniqueExercises
} from 'utils/copyExercisesToClipboard';

const createInvalidHandler =
  (name: string, min: number): (() => void) =>
  () => {
    snackbarState({
      type: 'generic',
      severity: 'error',
      message: `Please enter a number greater than ${min} for ${name}`
    });
  };

const onInvalidHoldExercise = createInvalidHandler('hold time', 1);
const onInvalidRepsExercise = createInvalidHandler('reps', 0);

export interface EditablePerisurgicalConfigProps {
  onAddExercises: (target: TargetProgression) => void;
}

export const EditablePerisurgicalActivityPlan = ({
  onAddExercises
}: EditablePerisurgicalConfigProps): JSX.Element | null => {
  const { draft } = useDraftActivityPlan();
  const {
    removeExercise,
    duplicateExercise,
    editExerciseDetails,
    moveExercise,
    deleteProgression,
    duplicateProgression,
    moveProgression,
    addProgression
  } = useDraftActivityPlanAPI();
  const currentProgressionNum = useCurrentProgressionNum();

  const handleAddProgression = async (): Promise<void> => {
    await addProgression();
    snackbarState({
      type: 'generic',
      severity: 'success',
      message: `New week has been created.`
    });
  };

  return draft ? (
    <EditablePerisurgicalActivityPlanUI
      activityPlan={draft}
      currentProgression={currentProgressionNum}
      onAddExercises={onAddExercises}
      onCopyAllExercises={copyAllExercises}
      onCopyUniqueExercises={copyUniqueExercises}
      onDeleteExercise={removeExercise}
      onDuplicateExercise={duplicateExercise}
      onEditExercise={editExerciseDetails}
      onMoveExercise={moveExercise}
      onInvalidHoldExercise={onInvalidHoldExercise}
      onInvalidRepsExercise={onInvalidRepsExercise}
      onDeleteProgression={deleteProgression}
      onDuplicateProgression={duplicateProgression}
      onMoveProgression={moveProgression}
      onAddProgression={handleAddProgression}
    />
  ) : null;
};
